<template>
  <layouts-auth-sidebar>
    <div class="fixed w-full z-50">
      <transition name="fade" mode="out-in">
        <div v-if="store.state.base.responsive.isMD">
          <div v-if="only_well_labo">
            <layouts-auth-mobile-header-well-labo :is_well_labo="is_well_labo"/>
          </div>
          <div v-else>
            <layouts-auth-mobile-header :is_well_labo="is_well_labo"/>
          </div>
        </div>
        <div v-else>
          <div v-if="only_well_labo">
            <layouts-auth-pc-header-well-labo :is_well_labo="is_well_labo"/>
          </div>
          <div v-else>
            <layouts-auth-pc-header :is_well_labo="is_well_labo"/>
          </div>
        </div>
      </transition>
    </div>
    <div class="flex min-h-screen flex-col pt-12 md:pt-14 pb-14 md:pb-0">
      <layouts-auth-width>
        <base-back-icon />
      </layouts-auth-width>
      <slot />
      <div class="w-full mt-auto pt-10">
        <layouts-auth-contents-footer />
      </div>
    </div>
    <div class="fixed w-full bottom-0 z-50">
      <transition name="fade" mode="out-in">
        <div v-if="store.state.base.responsive.isMD">
          <div v-if="!only_well_labo">
            <layouts-auth-mobile-footer />
          </div>
        </div>
      </transition>
    </div>
  </layouts-auth-sidebar>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue'
import { useStore } from '@/store/index'

import LayoutsAuthSidebar from '@/components/LayoutsAuthSidebar.vue'
import LayoutsAuthPcHeader from '@/components/LayoutsAuthPcHeader.vue'
import LayoutsAuthPcHeaderWellLabo from '@/components/LayoutsAuthPcHeaderWellLabo.vue'
import LayoutsAuthMobileHeader from '@/components/LayoutsAuthMobileHeader.vue'
import LayoutsAuthMobileHeaderWellLabo from '@/components/LayoutsAuthMobileHeaderWellLabo.vue'
import LayoutsAuthMobileFooter from '@/components/LayoutsAuthMobileFooter.vue'
import LayoutsAuthContentsFooter from '@/components/LayoutsAuthContentsFooter.vue'
import LayoutsAuthWidth from '@/layouts/AuthWidth.vue'
import BaseBackIcon from '@/components/BaseBackIcon.vue'
import { RoleAttributes } from '@/types/models/role'

export default defineComponent({
  components: {
    LayoutsAuthSidebar,
    LayoutsAuthPcHeader,
    LayoutsAuthPcHeaderWellLabo,
    LayoutsAuthMobileHeader,
    LayoutsAuthMobileHeaderWellLabo,
    LayoutsAuthMobileFooter,
    LayoutsAuthContentsFooter,
    LayoutsAuthWidth,
    BaseBackIcon
  },
  setup() {
    const store = useStore()
    const is_well_labo = ref()
    const only_well_labo = ref(false)

    onMounted(() => {
      // Authの全画面共通でAPI叩く
      Promise.allSettled([
        store.dispatch('menu/fetchMenuCategories')
      ])
      is_well_labo.value = !!store.state.user.user.roles.find((element:RoleAttributes) => element.slug === 'well_labo')
      only_well_labo.value = is_well_labo.value && store.state.user.user.roles.length === 1
    })

    return {
      store,
      is_well_labo,
      only_well_labo
    }
  },
})
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease-out;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
